<template>
  <div class="company-tabs">
    <b-card style="background: #f1f1f1">
      <div class="text-left mb-2">
        <span style="font-size: 0.8rem;">{{ $t('pages.admin.companies.total-label', 'Total companies:') }}</span> {{ totalRecords }}
      </div>
      <b-tabs content-class="mt-3">
        <b-tab
          v-for="tab of tabs"
          :key="tab.key"
          :title="tab.label + ' (' + categoryCompaniesCount(tab.key) + ')'"
          :active="tab.key === 'Pending'"
          @click="activeTab = tab.key"
        >
          <div class="bg-card">
            <div
              v-if="companies"
            >
              <pagination
                v-if="paginationMeta"
                :data="paginationMeta"
                size="small"
                :limit="1"
                align="center"
                @pagination-change-page="getCompanies"
              />
              <div
                v-for="company in companies.object"
                :key="company.id"
                class="text-left"
              >
                <CompanyCard :company="company" />
              </div>
              <pagination
                v-if="paginationMeta"
                :data="paginationMeta"
                size="small"
                :limit="1"
                align="center"
                @pagination-change-page="getCompanies"
              />
            </div>
            <div v-if="categoryCompaniesCount(tab.key) === 0">
              {{ $t('pages.admin.companies.no-companies', 'No companies yet...') }}
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import CompanyCard from '@/components/jobs/admin/CompanyCard';

export default {
  components: {
    CompanyCard
  },
  data() {
    return {
      companies: null,
      activeTab: 'Pending',
      paginationMeta: null,
      companyCounts: null
    }
  },
  computed: {
    tabs() {
      return [
        {
            key: 'Active',
            label: this.$t('pages.admin.companies.active', 'Active')
        },
        {
            key: 'Pending',
            label: this.$t('pages.admin.companies.pending', 'Pending')
        },
        {
            key: 'Rejected',
            label: this.$t('pages.admin.companies.rejected', 'Rejected')
        },
      ];
    },
    totalRecords() {
      let res = 0;
      for(let tabCount in this.companyCounts) {
        res += this.companyCounts[tabCount];
      }

      return res;
    }
  },
  watch: {
    activeTab: function(newVal) {
      let tab = newVal.toLowerCase();
      this.companies = null;
      this.paginationMeta = null;
      this.getCompanies(tab);
    }
  },
  mounted() {
    this.getCompaniesCounts();
    this.getCompanies();
  },
  methods: {
    getCompaniesCounts() {
      this.axios.get('/admin/companies_counts')
        .then( response => {
          this.companyCounts = response.data;
        })
        .catch();
    },
    categoryCompaniesCount(tabName) {
      let tab = tabName.toLowerCase();
      if(this.companyCounts) {
        return this.companyCounts[tab];
      } else {
        return 0;
      }
    },
    getCompanies(page = 1) {
      let tab = this.activeTab.toLowerCase();
      this.axios.get('/admin/companies/' + tab + '?page=' + page + '&isPaginated=true')
        .then( response => {
          this.companies = ({ tab: tab, object: response.data.data });
          this.paginationMeta = response.data;
        })
        .catch();
    }
  }
}
</script>

<style lang="scss">
  .tabs {
    .nav-item {
      padding: 0 15px !important;
    }
  }

  .nav-item {
    @media screen and (max-width: 767px) {
      width: 100%;
    }
  }
</style>
